/**
 * Utility module for show/hide a loading modal.
 */

var VRC = VRC || {};

VRC.LoadingModal =  (function () {
    var pleaseWaitDiv;
    var _loadingTemplate = WELL.Handlebars.VRC.loading_modal;

     return {
      show: function() {
        pleaseWaitDiv = $('#modal');
        pleaseWaitDiv.html(_loadingTemplate({}));
        pleaseWaitDiv.modal();
      },
      hide : function () {
        pleaseWaitDiv = $('#modal');
        pleaseWaitDiv.modal('hide');
      }
    };
  })();